export default [
  {
    name: 'getRegion',
    method: 'GET',
    path: '/vue/gis/region-get'
  },
  {
    name: 'getRegionList',
    method: 'POST',
    path: '/vue/gis/region-page'
  },
  {
    name: 'saveRegion',
    method: 'POST',
    path: '/vue/gis/region-save'
  },
  {
    name: 'deleteRegion',
    method: 'POST',
    path: '/vue/gis/region-delete'
  },
  {
    name: 'initRegion',
    method: 'GET',
    path: '/vue/gis/region-getByParentId'
  },
  {
    name: 'loadRegion',
    method: 'GET',
    path: '/vue/gis/region-getByParentId'
  },
  {
    name: 'searchRegion',
    method: 'POST',
    path: '/vue/gis/region-findList'
  },
  {
    name: 'getParentsPathById',
    method: 'GET',
    path: '/vue/gis/region-getParentsPathById'
  }
];
